import { getSeverityString, products } from '@fe/weather';
import React from 'react';
import { FlightImpactDto } from '../../../../flights/interop/flightDto';
import { DateTimeFormatter, UnitFormatter } from '../../../../formatters';
import useTimeNow from '../../../../hooks/use-time-now';
import { MonitorStatusBadge } from '../../../components/monitor-status/MonitorStatusBadge';

export default function FlightImpacts({ impacts }: { impacts: FlightImpactDto[] }) {
    // TODO: either put computed props in the record in the worker or compute them here, don't extend impact DTO with things that are needed for display only here
    const impactsSorted = React.useMemo(() => impacts.toSorted((a, b) => (a.startTime ?? 0) - (b.startTime ?? 0)), [impacts]);
    const now = useTimeNow({ intervalSeconds: 60 });

    const diffToTimeNow = React.useCallback((time: number) => {
        return Math.floor((time - now) / 60);
    }, []);

    return (
        <table className="cobalt-table cobalt-alternate overflow-auto m-2">
            <thead>
                <tr>
                    <th className="ps-2">Impact</th>
                    <th>Start time (+/- min)</th>
                    <th>End Time</th>
                    <th>Vendor</th>
                    <th>Severity</th>
                    <th>Dist</th>
                    <th>Alt Base</th>
                    <th>Alt Top</th>
                    <th>Product Name</th>
                    <th>Monitor Status</th>
                </tr>
            </thead>
            <tbody>
                {impactsSorted.map((impact) => {
                    const diffToNow = impact.startTime !== null ? diffToTimeNow(impact.startTime) : null;
                    return (
                        <tr key={impact.id}>
                            <td className="ps-2" style={{ maxWidth: '100px' }}>
                                {impact.name}
                                {import.meta.env.DEV && <span> ({impact.routeId})</span>}
                            </td>
                            <td>
                                <span>{DateTimeFormatter.formatTime(impact.startTime)}</span>
                                {diffToNow !== null && (
                                    <span>
                                        {' '}
                                        ({diffToNow > 0 ? '+' : ''}
                                        {diffToNow})
                                    </span>
                                )}
                            </td>
                            <td>{DateTimeFormatter.formatTime(impact.endTime)}</td>
                            <td>{products[impact.productCode].vendor}</td>
                            <td>{getSeverityString(impact.productCode, impact.severity) || '-'}</td>
                            <td>{impact.distanceOff}</td>
                            <td>{UnitFormatter.formatAltitude(impact.altitudeBase)}</td>
                            <td>{UnitFormatter.formatAltitude(impact.altitudeTop)}</td>
                            <td style={{ maxWidth: '170px' }}>{products[impact.productCode]?.name ?? '-'}</td>
                            <td>
                                <MonitorStatusBadge monitorStatus={impact.monitorStatus} />
                            </td>
                        </tr>
                    );
                })}
                {impactsSorted.length === 0 && (
                    <tr>
                        <td colSpan={99} className="text-center secondary-text">
                            No impacts.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
}
